import styled from 'styled-components';

import {
  mediaQueryLaptopMin,
  mediaQueryMobileLargeMin,
  fontFamilySecondary,
  colorAccent,
} from 'styles';

export const ConversionNumbersListWrapper = styled.div`
  @media all and ${mediaQueryMobileLargeMin} {
    display: grid;
    gap: 24px;
    grid-template-columns: 1fr 1fr;
  }

  @media all and ${mediaQueryLaptopMin} {
    gap: 32px;
  }
`;

export const Title = styled.div`
  font-family: ${fontFamilySecondary};
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  margin: 24px 0 8px;
`;

export const ConversionItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 8px;
  font-size: 14px;
  align-items: center;
  border-bottom: 1px solid #f5f5f5;

  &:nth-child(even) {
    background-color: #fbfbfb;
  }
`;

export const ConversionItemLink = styled.a`
  height: 56px;
  line-height: 55px;
  color: ${colorAccent};
  font-weight: 700;
  font-size: 16px;
`;
